<template>
  <v-app class="home-page" :key="updateLanguage">
    <header-comp :activeButton="3" :userInfo="userData" v-on:update="onStep1Update" />

    <v-container>
      <v-row>
        <v-col cols="6">
          <v-select
            class="mt-0 pt-0"
            :items="systemsData"
            v-model="selectedSystem"
            item-text="system.city"
            item-value="system.id"
            label="System"
            return-object
            @change="value => selectSystem(value)"
          >
            <template v-slot:selection="{ item, index }">
              <span :key="index">{{ item.system.id }} - {{ item.system | formatAddress }}</span>
            </template>
            <template v-slot:item="{ item, index }">
              <span :key="index">{{ item.system.id }} - {{ item.system | formatAddress }}</span>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row dense v-if="eventsData.length">
        <v-col cols="12" v-for="(event, index) in eventsData" :key="event.id">
          <h2
            v-if="!compareDates(eventsData[index], eventsData[index - 1])"
            class="md-whiteframe-6dp"
          >{{ formatEventDate(event) }}</h2>
          <div class="item-detail">
            <v-row class="m-0">
              <v-col md="2" sm="3" class="text-center">
                <span>{{ showDate(event.storedate) }}</span>
              </v-col>
              <v-col md="2" cols="2" class="text-center">
                <i :class="[chooseMessage(event), 'icon-large']"></i>
              </v-col>
              <v-col md="8" sm="6">
                <p>{{`event_messgae_type_${event.messagetype}` | translate }}
                  <span v-if="event.messagetype == '6'"> {{ formatSubscriptionTierLabel(event.subtype) }}</span>                
                  <span v-if="event.messagetype == '7'"> {{ formatContractTierLabel(event.subtype) }}</span>                
                </p>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row v-else dense>
        <v-col cols="12" class="item-detail d-flex align-center justify-center">
          <span>{{ 'lng_no_event_logs_txt' | translate }}</span>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import moment from "moment";
import HeaderComp from "../../components/HeaderComp";
import GlobalService from "../../services/global-service";
import onStep1Update from "../../mixins/ChangeLanguage"
import { formatSubscriptionTierLabel, formatContractTierLabel} from '../../common/HelperFunctions';

export default {
  name: "EventLogs",
  components: {
    HeaderComp
  },
  data: () => ({
    bottom: false,
    offsetNumber: 0,
    count: 100,
    eventsData: [],
    token: 0,
    englishTranslation: window.selectedLang,
    systemsData: undefined,
    selectedSystem: undefined,
    userData: undefined,
    scrollHandler: undefined,

  }),
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.offsetNumber += 100;
        this.fetchEventsData(this.selectedSystem.system.id);
      }
    }
  },
  created() {
    // Keep a stable handler reference so we can remove it in `beforeDestroy`.
    this.scrollHandler = () => {
      this.bottom = this.bottomVisible();
    };
    window.addEventListener("scroll", this.scrollHandler);
  },
  mounted() {
    this.token = sessionStorage.getItem("userToken");
    const userDataRaw = sessionStorage.getItem("userData");
    const systemsDataRaw = sessionStorage.getItem("systemsData");

    try {
      this.userData = userDataRaw ? JSON.parse(userDataRaw) : {};
    } catch (e) {
      this.userData = {};
    }

    try {
      this.systemsData = systemsDataRaw ? JSON.parse(systemsDataRaw) : undefined;
    } catch (e) {
      this.systemsData = undefined;
    }

    if (this.systemsData && this.systemsData.length) {
      this.selectSystem(this.systemsData[0]);
    }
  },
  beforeDestroy() {
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
  },
  mixins:[onStep1Update],
  methods: {
    formatSubscriptionTierLabel,
    formatContractTierLabel,
    selectSystem(system){
      if(system.system.id){
        this.eventsData = []
        this.offsetNumber = 0;
        this.selectedSystem = system
        this.fetchEventsData(system.system.id);
      }
    },
    async fetchEventsData(sysId) {
      let apiData = await GlobalService.getEventsList(
        sysId,
        this.token,
        this.offsetNumber,
        this.count
      );
      this.eventsData = this.eventsData.concat(apiData);
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= (pageHeight - 5);
      return bottomOfPage || pageHeight < visible;
    },
    compareDates(curr, prev) {
      if (!prev) return false;
      return (
        moment(curr.storedate).format("YYYY-MM-DD") ===
        moment(prev.storedate).format("YYYY-MM-DD")
      );
    },
    chooseDeviceType(event) {
      if (event.devicetype === "1") {
        return "icon-retweet";
      } else if (event.devicetype === "0") {
        return "icon-home";
      }
    },
    chooseMessage(event) {
      switch (String(event.messagetype)) {
        case "0":
          return "icon-warning-sign";
        case "1":
          return "icon-remove-circle";
        case "2":
          return "icon-check";
        case "3":
          return "icon-check";
        case "4":
          return "icon-remove-circle";
        case "5":
          return "icon-user";
        case "6":
          return "icon-exchange";
        case "7":
          return "icon-exchange";
        default:
          break;
      }
    },
    formatEventDate(event) {
      let translation = {
        Monday: "lng_monday",
        Tuesday: "lng_tuesday",
        Wednesday: "lng_wednesday",
        Thursday: "lng_thursday",
        Friday: "lng_friday",
        Saturday: "lng_saturday",
        Sunday: "lng_sunday"
      };
      let day = moment(event.storedate).format("dddd"); //jshint ignore:line
      return (
        this.englishTranslation[`${translation[day]}`] +
        " " +
        moment(event.storedate).format("DD/MM-YYYY")
      ); //jshint ignore:line
    },
    showDate(value){
      return moment(value).format("DD/MM/YYYY HH:mm")
    }
  }
};
</script>
<style>
.md-whiteframe-6dp {
  text-transform: capitalize;
  text-align: center;
  background: #0a7894;
  color: #fff;
  -moz-border-radius: 5px;
  border-radius: 5px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  line-height: 2rem;
  font-size: 1.79rem;
  margin: 1.2rem 0;
}
.item-detail {
  border: 1px solid #0a7894;
  border-radius: 5px;
}
.item-detail p {
  margin-bottom: 0 !important;
}
.item-detail :hover {
  background-color: #0a7894;
  color: #fff;
}
</style>
